import gql from 'graphql-tag';

export const GetCollabPermissionTokenQuery = gql`
	query getCollabToken($contentId: ID!, $draftShareId: String) @SLA {
		collabToken(id: $contentId, draftShareId: $draftShareId) {
			token
		}
	}
`;
